import styled from 'styled-components';

const styledLabelTrfs = ['P8-18.1', 'P7-12', 'P6-28'];
export const StyleFailureNewDropdown = styled.div`

#F619AsLeftTestRequired-wrapper > .Dropdown-root > .Dropdown-control > .Dropdown-menu {
    text-align: ${props => (['P7-26', 'P7-25', 'M7-1', 'M6-11', 'M6-14', 'M6-15', 'M6-1'].includes(props.formName)) ? 'center' : 'left'};
}
.Dropdown-placeholder.is-selected {
    width: 100%;
    overflow: hidden;
}
.Dropdown-menu {
    text-align: center;
}
`;

export const StyleMagneticFloatCheckDropdown = styled.div`
.Dropdown-placeholder.is-selected {
    width: 100%;
    overflow: hidden;
}
.Dropdown-menu {
    text-align: center;
}
`;

export const StyledLabelTab = styled.div`
#F1047MeasuredDielectricConstantLabel { 
    @media only screen and (max-width: 960px) {
        padding: ${props => (styledLabelTrfs.includes(props.formName)) ? '0px 25px 5px 0px' : props.padding};
    }
    @media only screen and (min-width: 961px) {
        padding: ${props => (styledLabelTrfs.includes(props.formName)) ? '10px 25px 5px 0px' : props.padding};
    }
}
#F1048ConfiguredDielectricConstantLabel { 
    @media only screen and (max-width: 960px) {
        padding: ${props => (styledLabelTrfs.includes(props.formName)) ? '0px 25px 5px 0px' : props.padding};
    }
    @media only screen and (min-width: 961px) {
        padding: ${props => (styledLabelTrfs.includes(props.formName)) ? '10px 25px 5px 0px' : props.padding};
    }
}
`;
